import { CollaboratorKind } from '@/types/schema';

/** COLLABORATOR KINDS */
export const COLLABORATOR_KIND_DISPLAY_NAMES: Record<CollaboratorKind, string> =
  {
    ATTORNEY: 'Attorney',
    CLIENT: 'Client',
    CPA: 'CPA',
    OTHER: 'Other',
    FINANCIAL_ADVISOR: 'Financial Advisor',
  };
